;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import SearchMagnifyingGlassIconButton from "../SearchMagnifyingGlassIconButton"

const SearchBarUnfocused = ({
  searchTerm,
  setSearchBarFocused,
  location,
  searchPlaceholder,
}) => {
  const renderNoSearchTerm = () => {
    return (
      <div className="flex justify-center ">
        <div
          className={
            "flex flex-row items-center h-[68px] my-[6.5px] bg-white rounded-[80px] text-black w-full max-w-[884px] hover:cursor-pointer hover:shadow-[0px_2px_20px_0px_rgba(0,0,0,0.5)] px-[10px]"
          }
          onClick={() => setSearchBarFocused(true)}
        >
          <div className="  flex justify-center items-center">
            <SearchMagnifyingGlassIconButton
              onClick={() => setSearchBarFocused(true)}
            />
          </div>
          <div
            className={
              "text-[#9E9E9E] text-[19px] tracking-[.57px] pl-[15px] min-[800px]:pl-[20px]"
            }
          >
            {searchPlaceholder}
          </div>
        </div>
      </div>
    )
  }

  const renderSearchTerm = () => {
    return (
      <div className="flex justify-center ">
        <div
          className={
            "flex flex-row items-center justify-between h-[81px] bg-white rounded-[80px] text-black w-full max-w-[884px] hover:cursor-pointer  hover:shadow-[0px_2px_20px_0px_rgba(0,0,0,0.5)] pl-[30px] pr-[15px]"
          }
          onClick={() => setSearchBarFocused(true)}
        >
          <div
            className={
              "flex flex-col items-start min-[600px]:flex-row min-[600px]:items-center w-full"
            }
          >
            <div
              className={
                "line-clamp-1 min-[600px]:line-clamp-2 min-[600px]:min-w-[35%]"
              }
            >
              {searchTerm}
            </div>

            <div className="flex flex-row items-center pt-[10px] min-[600px]:pt-0">
              <div className="hidden min-[600px]:block h-[67px] w-[1px] bg-[#CECECE] mx-[12px]" />
              <div
                className={
                  "text-[#AAAAAA] min-[600px]:text-black line-clamp-1 min-[600px]:line-clamp-2 min-[600px]:min-w-[35%]"
                }
              >
                {location}
              </div>
            </div>
          </div>
          <div className=" flex justify-center items-center">
            <SearchMagnifyingGlassIconButton
              onClick={() => setSearchBarFocused(true)}
            />
          </div>
        </div>
      </div>
    )
  }

  return searchTerm ? renderSearchTerm() : renderNoSearchTerm()
}
export default SearchBarUnfocused
